// Casino player profile returned by GET /api/user. The address is the player's
// home address; every field is an empty string when the casino has none.
export interface PlayerAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  stateCode: string;
  postalCode: string;
  country: string;
}

export interface CurrencyBalance {
  currencyCode: string;
  currencyValue: string;
}

export interface AccountBalance {
  accountId: string;
  accountBalance: string;
  currencyBalance: CurrencyBalance[];
}

export interface User {
  accountNumber: string;
  accountStatus: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  dateOfBirth: string;
  tierCode: number;
  tierName: string;
  address: PlayerAddress;
  balance: AccountBalance;
}
